import React, { Component, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';

import { Navigate } from 'react-router-dom';
import BottomMenu from '../../Menus/BottomMenu';
import './game-player-menu.css';
import Transcripts from '../../Transcripts/Transcripts';
import { DeckBar } from '../Components/Views/DeckBar';
import { GameStateBar } from './GameStateBar';
import { PlayerScoreBar } from '../Components/Views/ScoreBars';

const VARIANTS = [
    null, 'deep', 'stem', 'hex', 'dread', 'honored', 'seed'
];

function MenuButton(props) {
    let gamePlayerData = props.gamePlayerData;
    const [backState, setBackState] = useState(false);

    if (backState) {
        props.app.gameController.disconnect();
        return <Navigate to={'/play'} />
    }

    return (<div id={'button-wrapper'} className={'button-wrapper'}>
        <Dropdown>
            <Dropdown.Toggle
                variant={VARIANTS[gamePlayerData.faction]}
                id="dropdown-basic"
                className={'game-player-menu-button'}
            >
                &#9776;
            </Dropdown.Toggle>

            <Dropdown.Menu>
                <Dropdown.Item>
                    {props.isActivePlayer &&
                        <Button style={{ width: '100%' }}
                                variant={'deep'}
                                onClick={() => props.app.game.seatedController.gamePlayerApi.clickNext()}
                        >
                            Next
                        </Button>
                    }
                </Dropdown.Item>
                <Dropdown.Item>
                    {props.isActivePlayer &&
                        <Button style={{ width: '100%' }}
                                variant={'stem'}
                                onClick={props.app.gameController.reloadSeatedGamePlayerChoice}
                        >
                            Reload Current Choice
                        </Button>
                    }
                </Dropdown.Item>
                <Dropdown.Item>
                    <Transcripts {...props} />
                </Dropdown.Item>
                <Dropdown.Item>
                    <Button style={{ width: '100%' }}
                            variant={'hex'}
                            onClick={() => {
                                setBackState(true);
                            }}>Menu</Button>
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown></div>
    );
}

export default class GamePlayer2dMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {message: 'Loading'}
    }

    displayMessage = (message) => {
        this.setState({message: message});
    }

    render() {
        let gamePlayerData = this.props.gamePlayerData;
        if (!gamePlayerData) {
            return <></>;
        }

        let gameData = this.props.gameData;
        let isActivePlayer = gameData.active_player === gamePlayerData.id;

        let props = {...this.props, ...this.state, isActivePlayer: isActivePlayer}

        let activePlayer = gameData.active_player;
        let playerIndex = gameData.gameplayer_set.findIndex(
            gamePlayerData => gamePlayerData.id === activePlayer);
        let activePlayerData = {};
        let activePlayerName = '';
        let message = 'Waiting';
        if (playerIndex >= 0) {
            activePlayerData = gameData.gameplayer_set[playerIndex];
            activePlayerName = activePlayerData.display_name;
        }

        return (<>
                <div className={'game-player-menu-top-spacer'} />
                <div id={'game-player-menu'}
                     className={'game-player-menu'}
                >
                    {/* <div className={'game-player-menu-item'} onClick={ */}
                    {/*     () => { */}
                    {/*         this.props.app.menuController.changeToMenu('lobby'); */}
                    {/*     } */}
                    {/* }> */}
                    {/*     {gamePlayerData.seat}-{gamePlayerData.name} */}
                    {/* </div> */}
                    <div className={'game-player-menu-item game-player-menu-round-number'}>
                        &#128257;{gameData.current_round}
                    </div>
                    <div className={'game-player-menu-item'}>
                        <GameStateBar {...this.props} />
                    </div>
                    <div className={'game-player-menu-item'}>
                        <DeckBar {...this.props} />
                    </div>
                    <div className={'game-player-menu-item game-player-menu-score-bar'}>
                        <PlayerScoreBar gamePlayerData={gamePlayerData}/>
                    </div>
                    <div className={'game-player-menu-item'} style={{marginLeft: 'auto'}}>
                        <div className={'game-player-menu-item-message'}>
                            {activePlayerName}
                            <br/>
                            {message}
                        </div>
                    </div>
                    {/* <div className={'game-player-menu-item'}> */}
                    {/*     <FtueQuestionMark {...this.props}/> */}
                    {/* </div> */}
                    {/* <MenuButton {...props}/> */}
                    {/* {isActivePlayer && */}
                    {/*     <div className={'game-player-menu-item'}> */}
                    {/*         <BigButton {...this.props}>Next</BigButton> */}
                    {/*     </div> */}
                    {/* } */}
                    {/* {!isActivePlayer && */}
                    {/*     <div className={'game-player-menu-item'}> */}
                    {/*         Waiting */}
                    {/*     </div> */}
                    {/* } */}

                </div>

                <BottomMenu {...this.props} />
            </>
        );
    }
}
